import axios, {AxiosResponse} from 'axios'
import {ILocationDropFilter, ILocationDropModel, ILocationModel} from './LocationModel'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels' 

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL
export const LOCATION_CREATE_URL = `${API_URL}api/v1/definition/location/create`
export const LOCATION_GET_ALL_URL = `${API_URL}api/v1/definition/location/all`
export const LOCATION_DELETE_URL = `${API_URL}api/v1/definition/location/delete/`
export const LOCATION_UPDATE_URL = `${API_URL}api/v1/definition/location/update/`
export const LOCATION_DROP_LIST_URL = `${API_URL}api/v1/definition/location/getAllLocationDropList`

export function createLocation(locationData: ILocationModel) {
  return axios.post(LOCATION_CREATE_URL, locationData)
}

export function updateLocation(locationData: ILocationModel) {
  return axios.patch(LOCATION_UPDATE_URL + locationData.id, locationData)
}

export async function loadLocations(
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ILocationModel>>>> {
  return axios.get(LOCATION_GET_ALL_URL, {
    params: {page, size, sort, order},
  })
}
 
export function deleteLocation(locationId: string) {
  return axios.delete(LOCATION_DELETE_URL + locationId)
}

export async function loadLocationDropList(
  page = 0,
  size = 20,
  filter: ILocationDropFilter = {},
  sort?: string,
  order?: 'asc' | 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ILocationDropModel>>>> {
  const params: Record<string, string | number> = {page, size}
  if (sort) params.sort = sort
  if (order) params.order = order
  if (filter.branchId) params.branchId = filter.branchId
  if (filter.pickupLocationId) params.pickupLocationId = filter.pickupLocationId
  if (filter.returnLocationId) params.returnLocationId = filter.returnLocationId
  return axios.get(LOCATION_DROP_LIST_URL, {params})
}
